export class Canton {
    codCanton: number;
    codProvincia: number;
    nomCanton: string;
}
